var render = function render(){var _vm=this,_c=_vm._self._c;return _c('the-navbar-button',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('v-subheader',_vm._g({staticClass:"text-subtitle-2 font-weight-regular py-1 px-2 font--text",staticStyle:{"height":"auto"},domProps:{"textContent":_vm._s(_vm.additionalModuleName)}},_vm.$listeners))]},proxy:true}])},'the-navbar-button',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }